export var MOBILE_MIN_WIDTH = 320;
export var TABLET_MIN_WIDTH = 768;
export var DESKTOP_MIN_WIDTH = 1025;